var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 919,
    viewBox: "0 0 1920 919",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-color",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 918.333,
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32",
    width: 918,
    height: 273.333,
    transform: "matrix(0 1 -1 0 1920 0)",
    fill: "#ADD8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32.1",
    width: 1062,
    height: 300.06,
    transform: "matrix(0 1 -1 0 1836 -93)",
    fill: "#80B9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32.2",
    width: 1070,
    height: 337,
    transform: "matrix(0 1 -1 0 1727 -79)",
    fill: "#559CE4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32.3",
    width: 918,
    height: 352.952,
    transform: "matrix(0 1 -1 0 1579.94 0)",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32.4",
    width: 918,
    height: 496,
    transform: "matrix(0 1 -1 0 1405 0)",
    fill: "#235A9F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32.5",
    width: 918,
    height: 655,
    transform: "matrix(0 1 -1 0 1191 0)",
    fill: "#174276"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32.6",
    width: 918,
    height: 947,
    transform: "matrix(0 1 -1 0 947 0)",
    fill: "#092642"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 918.333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderColor);
export default __webpack_public_path__ + "static/media/header-color.089f51235bc8528edc82b420abf10877.svg";
export { ForwardRef as ReactComponent };